import React, {FC, useMemo} from 'react';
import {AttachmentArea, FileUploader} from 'components-lib';
import {IWithDisabled} from 'models';
import {useDragAndDrop} from 'hooks';

interface IBrowseButtonProps extends IWithDisabled {
  name: string;
  accept?: string;
  withOnlyBrowseButton?: boolean;
  loading?: boolean;
}

export const BrowseButton: FC<IBrowseButtonProps> = ({name, accept, disabled, loading, withOnlyBrowseButton}) => {
  const {
    file,
    error,
    fileInputRef,
    addFileClickHandler,
    cancelFileDialogHandler,
    deleteClickHandler,
    openFileDialogClickHandler,
  } = useDragAndDrop(name);

  const attachmentArea = useMemo(
    () => <AttachmentArea file={file} error={error} loading={loading} deleteCallback={deleteClickHandler} />,
    [error, loading, deleteClickHandler, file]
  );

  return (
    <FileUploader.Horizontal
      disabled={disabled}
      title=""
      text=""
      align="flex-start"
      buttonSize="small"
      browseButtonText="Reupload"
      withIcon={false}
      attachmentArea={attachmentArea}
      fileInputName={name}
      accept={accept}
      file={file}
      fileInputRef={fileInputRef}
      error={error}
      withOnlyBrowseButton={withOnlyBrowseButton}
      addFileCallback={addFileClickHandler}
      cancelFileCallback={cancelFileDialogHandler}
      openFileDialogClickHandler={openFileDialogClickHandler}
    />
  );
};
